import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Storage } from "@mui/icons-material";
import { useTableVariant } from "../TableVariantContext";

/**
 * OpenCirc Indicator Component
 * Reusable component for displaying database icon with pending/active dataset indicators
 * 
 * @param {Object} props
 * @param {Object} props.component - Component data object
 * @param {Function} props.onClick - Click handler function
 */
const OpenCircIndicator = ({ component, onClick }) => {
  const isLovable = useTableVariant() === "lovable";
  const hasPending = component?.external_dataset_state === "PENDING";
  const isActive = component?.external_dataset_state === "ACTIVE";
  const idleColor = isLovable ? "#94a3b8" : "#666";
  const activeColor = isLovable ? "#34d399" : "#00D9A5";

  const getTooltipText = () => {
    if (!component) {
      return "Komponent data";
    }
    if (isActive) {
      return `Ekstern data aktiv\nKilde: ${component?.active_dataset?.source || "OpenFrame"}`;
    }
    if (hasPending) {
      return `Ny ekstern data tilgængelig – kræver aktivering\nKilde: ${component?.pending_dataset?.source || "OpenFrame"}`;
    }
    return "Komponent data";
  };

  const handleClick = (e) => {
    e.stopPropagation(); // Prevent row selection
    e.preventDefault(); // Prevent default behavior
    if (onClick) {
      onClick(component);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "40px", width: "100%" }}>
      <Tooltip title={getTooltipText()} arrow>
        <span>
          <IconButton
            size="small"
            onClick={handleClick}
            className={[
              isLovable ? "lovable-opencirc-btn" : "",
              isLovable && isActive ? "lovable-opencirc-btn--active" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            style={{
              padding: "4px",
              position: "relative",
              cursor: "pointer",
            }}
          >
          <Storage
            style={{
              fontSize: "20px",
              color: isActive ? activeColor : idleColor,
            }}
          />
          {hasPending && (
            <span
              className={isLovable ? "lovable-opencirc-badge" : undefined}
              style={{
                position: "absolute",
                top: "-2px",
                right: "-2px",
                width: "8px",
                height: "8px",
                background: activeColor,
                border: "2px solid white",
                borderRadius: "50%",
                animation: "pulse 2s infinite",
              }}
            />
          )}
          {isActive && !hasPending && (
            <span
              style={{
                position: "absolute",
                top: "-4px",
                right: "-4px",
                width: "16px",
                height: "16px",
                background: activeColor,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "10px",
                fontWeight: "bold",
              }}
            >
              ✓
            </span>
          )}
          </IconButton>
        </span>
      </Tooltip>
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.6;
            }
          }
        `}
      </style>
    </div>
  );
};

export default OpenCircIndicator;


